import { render, staticRenderFns } from "./TheProfile.vue?vue&type=template&id=7e4740de&"
import script from "./TheProfile.vue?vue&type=script&lang=js&"
export * from "./TheProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports